module.exports = __webpack_public_path__ + "img/power_strip_power.b899caaa.png";